export const BUSINESS = {
  name: "Georgios (George) Economou",
  abn: "22 819 847 639",
  address: "Cheltenham SA 5011",
  email: "ElitePerformanceDevelopmentLab@gmail.com",
  phone: "0499 354 667",
  phoneHref: "tel:+61499354667",
};

export const LEGAL_LINKS = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms & Conditions" },
  { to: "/refund-policy", label: "Refund & Cancellation Policy" },
  { to: "/child-safety", label: "Child Safety Policy" },
  { to: "/contact", label: "Contact Us" },
];

export const META_DISCLAIMER =
  "This site is not a part of the Facebook website or Meta Platforms, Inc. Additionally, this site is NOT endorsed by Meta in any way. FACEBOOK is a trademark of META PLATFORMS, INC.";
